
window.getDropdowns = function() {

  const openElements = document.querySelectorAll('[data-toggle="show-dropdown"]')

  openElements.forEach((toggleElement) => {
    toggleElement.addEventListener("click", () => {
      var windowSelector = toggleElement.getAttribute("data-target")
      var windowElements = document.querySelectorAll(windowSelector)

      windowElements.forEach((windowElement) => {
        windowElement.classList.remove("hidden")
        windowElement.classList.add("shown")
      })

      var scrollingElement = windowElements[0]
      scrollingElement.scrollIntoView()
      
    })
  })

  const closeElements = document.querySelectorAll('[data-close="dropdown"]')

  closeElements.forEach((closeElement) => {
    closeElement.addEventListener("click", () => {
      var goalElementSelector = closeElement.getAttribute("data-target")
      var goalElements = document.querySelectorAll(goalElementSelector)

      goalElements.forEach((dropdownItem) => {
        dropdownItem.classList.remove("shown")
        dropdownItem.classList.add("hidden")
      })

    })
  })
}

window.getCollapses = function () {
  const collapseLists = document.querySelectorAll('[data-my-toggle="collapse-list"]')

  collapseLists.forEach((listItem) => {
    var toggleSelector = listItem.getAttribute("data-my-target")
    var className = `${toggleSelector.slice(1, toggleSelector.length)}--expanded`
    var clickItems = listItem.querySelectorAll(toggleSelector)

    clickItems.forEach((elementItem) => {
      elementItem.addEventListener("click", () => {
        if (elementItem.classList.contains(className)) {
          elementItem.classList.remove(className)
        }
        else {
          elementItem.classList.add(className)
        }

      })
    })
  })
}




